module.exports = __webpack_public_path__ + "static/media/a26.a48a87a4.jpg";